import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import OrderModel from "../../model/OrderModel";
import ClientModel from "../../model/ClientModel";
import DeliveryModel from "../../model/DeliveryModel";
import UserModel from "../../model/UserModel";
import {EnumUserType} from "../../enum/EnumUserType";
import ExcelModel from "../../model/ExcelModel";
import WebPayModel from "../../model/WebPayModel";


export class PageOrderStore {
    private rootStore: RootStore | undefined;

    files = [];
    report = [];

    isModalOpen = false;

    limitRow = 10;

    downloadLink: string = '';

    arItems = [];
    arModalData = [];

    selectedOption = {
        Client: {value: '', label: ''},
        Status: {label: 'Заказы со статусом', value: ''},
        Points: {label: 'Торговая точка', value: ''},
        Users: {label: 'Заказы учётной записи', value: ''},
    }


    dateFrom = '';
    dateTo = '';
    search = '';

    radioId = 0;
    radioIdStatus = '';
    downloadPopupInfo = false

    setSelectedOption = {
        Client: null,
        Status: null,
        Points: null,
        Users: null,
    }


    options = {
        Status: [
            {value: 0, label: 'Все'},
            {value: 'canceled', label: 'Отменен'},
            {value: 'blocked', label: 'Заблокирован'},
            {value: 'harmonization', label: 'На согласовании'},
            {value: 'accepted', label: 'Принят в обработку'},
            {value: 'assembling', label: 'На сборке'},
            {value: 'assembled', label: 'Собран'},
            {value: 'loaded', label: 'Отгружен'},
            {value: 'shipped', label: 'Доставлен'},
            {value: 'created', label: 'Создан'},
            {value: 'draft', label: 'Черновик'},
            {value: 'passed_courier', label: 'Передан курьерской службе'},
        ],
        Points: [],
        Users: [],
    }

    pagination = {
        countPage: 1,
        countRow: 1,
        currentPage: 1
    }

    openWebPayModalWindowAboutRedirect = false



    public error: string = '';
    redirectWebPayUrl: string = ""
    paymentType: number = 0
    isPaid: boolean = false

    setRadio = (id: number, status: string, formOfPayment: number, isPaid: boolean ) => {
        this.redirectWebPayUrl = ""
        this.radioId = id;
        this.setCsvData();
        this.radioIdStatus = status;
        if (formOfPayment === 7 && !isPaid){
            this.paymentType = 7
            this.isPaid = false

           this.takeWebPayLink(id)
        }
    }

    @action
    setCsvData = () => {
        if (this.radioId) {
            this.downloadLink=ExcelModel.getDownloadLink(this.radioId);
        }
    }
    @action
    takeWebPayLink = (id: number) => {
        WebPayModel.getOrderWebPayLink(id, this.setWebPayLink, this.setError)
    }
    @action
    removeWebPayLink = () => {
        this.redirectWebPayUrl = ""
    }
    @action
    setWebPayLink = (result: any) => {
        if (result) {
            this.redirectWebPayUrl = result.data.data.redirectUrl
        }
    }

    @action
    uploadFile=()=>{

    }


    setDateTo = (e: { target: { value: string } }) => {
        this.dateTo = e.target.value;
    }

    setDateFrom = (e: { target: { value: string } }) => {
        this.dateFrom = e.target.value;
    }

    setSearch = (e: { target: { value: string } }) => {
        this.search = e.target.value;
    }


    orderToBasket = (id: number) => {
        OrderModel.repeat({
            id: id,
            clientId: this.rootStore?.mainStore.getClientId()
        }, this.repeatOrder, this.setError)
    }


    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;

        // @ts-ignore
        this.setSelectedOption = {
            // @ts-ignore
            Client: this.setSelectedOptionClient,
            // @ts-ignore
            Status: this.setSelectedOptionStatus,
            // @ts-ignore
            Points: this.setSelectedOptionPoints,
            // @ts-ignore
            Users: this.setSelectedOptionUsers,
        }
    }

    setSelectedOptionClient = (e: any) => {
        this.selectedOption.Client = e;
    }

    setSelectedOptionStatus = (e: any) => {
        this.selectedOption.Status = e;
    }

    setSelectedOptionPoints = (e: any) => {
        this.selectedOption.Points = e;
    }

    setSelectedOptionUsers = (e: any) => {
        this.selectedOption.Users = e;
    }


    @action init() {

        this.initFilter();
    }

    @action initFilter() {
        ClientModel.getClients(this.setClients, this.setError);
        this.rootStore?.pageCatalogStore.getAllCatalogList()
    }

    @action
    setClients = (result: any) => {
        this.setData(result.data, 'Client', 'fullName', true);
        let clientId = this.rootStore?.mainStore.getClientId();

        UserModel.getAllChildren(this.setUsers, this.setError);
        DeliveryModel.getPoints(clientId, this.getPoints, this.setError);
    }

    @action
    setUsers = (result: any) => {
        const type = this.rootStore?.mainStore.getUserType();
        let setAll = type !== EnumUserType.clientUser;
        this.setData(result.data.row, 'Users', 'email', true,setAll);
        this.reload(true);
    }

    defaultFilter() {
        this.selectedOption = {
            Client: {value: '', label: ''},
            Status: {label: 'Заказы со статусом', value: ''},
            Points: {label: 'Торговая точка', value: ''},
            Users: {label: 'Заказы учётной записи', value: ''},
        }
        this.dateFrom = '';
        this.dateTo = '';
        this.search = '';
        this.initFilter();
    }

    @action
    getPoints = (result: any) => {
        this.setData(result.data, 'Points', 'name', false, true);
    }

    setData(result: any, keyData: string, keyName: string, set = true, all = false) {
        // @ts-ignore
        this.options[keyData] = [];
        if (result?.length) {


            if (all) {
                // @ts-ignore
                this.options[keyData].push({
                    // @ts-ignore
                    value: 0,
                    // @ts-ignore
                    label: 'Все',
                });
            }


            result.map((item: any) => {
                // @ts-ignore
                this.options[keyData].push({
                    // @ts-ignore
                    value: item?.id,
                    // @ts-ignore
                    label: item[keyName],
                });
                return item;
            });
            if (set) {
                // @ts-ignore
                this.selectedOption[keyData] = {
                    // @ts-ignore
                    value: result[0]?.id,
                    // @ts-ignore
                    label: result[0][keyName],
                }
            }
        }
    }


    @action
    setOrders = (result: any) => {
        result.data.rows.map((item: any) => {
            item.createdAt = new Date(item.createdAt);
            item.shipDate = new Date(item.shipDate);
            return item;
        });
        this.arItems = result.data.rows;
        if (this.arItems.length) {
            // @ts-ignore
            this.setRadio(this.arItems[0].id, this.arItems[0].status, 0 , false);
        }else{
            this.setRadio(0, '', 0 , false);
        }
        this.pagination = result.data.pagination;

        console.log("444444444444444444444444444")
        console.log(this.arItems[0])
        // @ts-ignore
        if (!this.arItems[0].isPaid && this.arItems[0].formOfPayment === 7){
            // @ts-ignore
            this.takeWebPayLink(this.arItems[0].id)
        }
        // if ( window.localStorage.getItem("order") === "1" && this.arItems.length){
        //
        //     // window.localStorage.setItem("order", "0")
        //     // @ts-ignore
        //     document.location.href = '/order/' + this.arItems[0].id
        //     // this.openWebPayModalWindowAboutRedirect = true
        // }
    }

    @action
    setCloseWebPayModalWindow = () => {
        this.openWebPayModalWindowAboutRedirect = false
        if ( window.localStorage.getItem("order") === "1" && this.arItems.length){

            window.localStorage.setItem("order", "0")
            // @ts-ignore
            document.location.href = '/order/' + this.arItems[0].id
            // this.openWebPayModalWindowAboutRedirect = true
        }
    }

    @action
    setOpenWebPayModalWindowAboutRedirect = () => {
        this.openWebPayModalWindowAboutRedirect = true
    }

    @action
    setError = (error: any) => {
        console.log(error)
    }

    onCurrentPage = (page: number) => {
        this.pagination.currentPage = page;
        this.reload();
    }

    filterSubmit = () => {
        this.reload(true);
    }
    filterClear = () => {
        this.defaultFilter();
        this.reload(true);
    }

    setFilter = () => {
        let filter = {
            clientId: this.rootStore?.mainStore.getClientId(),
        };
        if (this.selectedOption.Status?.value) {
            // @ts-ignore
            filter = {...filter, status: this.selectedOption.Status?.value}
        }
        if (this.selectedOption.Points?.value) {
            // @ts-ignore
            filter = {...filter, tradePointId: this.selectedOption.Points?.value}
        }
        if (this.selectedOption.Users?.value) {
            // @ts-ignore
            filter = {...filter, userId: this.selectedOption.Users?.value}
        }

        if (this.dateFrom) {
            // @ts-ignore
            filter = {...filter, createdAtFrom: this.dateFrom}
        }

        if (this.dateTo) {
            // @ts-ignore
            filter = {...filter, createdAtTo: this.dateTo}
        }

        if (this.search) {
            // @ts-ignore
            filter = {...filter, search: this.search}
        }

        return filter;
    }

    reload(init: boolean = false) {
        if (init) {
            this.pagination.currentPage = 1;
        }
        OrderModel.getOrders(this.getOrderModelData(), this.setOrders, this.setError);
    }

    getOrderModelData() {
        return {
            json: {
                limit: this.limitRow,
                filter: this.setFilter(),
            },
            page: this.pagination.currentPage
        };
    }

    deleteOrder = (id: number) => {
        if (window.confirm('Удалить черновик?')) {
            OrderModel.deleteOrder(id, this.setReload, this.setError);
        }
    }

    setReload = (result: any) => {
        this.reload();
        this.radioId = 0;
        this.radioIdStatus = '';
    }

    repeatOrder = (result: any) => {
        this.rootStore?.mainStore.setRedirectUrl('/basket');
    }

    orderToCreated = (id: number) => {
        OrderModel.changeStatus(id, this.setReload, this.setError);
    }

    @action
    onCloseModal = () => {
        this.isModalOpen = false;
    }

    @action
    onOpenModal = (id: number) => {
        this.arModalData = [];
        this.isModalOpen = true;
        OrderModel.getProductInfoOrder(id, this.setModalData, this.setError)
    }

    @action
    setModalData = (result: any) => {
        this.arModalData = result.data;
    }

    @action
    onDrop = (files: any) => {
        this.downloadPopupInfo = true
        let clientId = this.rootStore?.mainStore.getClientId();
        this.files=files;
        let file = files[0];
        let formData = new FormData();
        formData.append('file', file);
        ExcelModel.uploadOrder(clientId,formData, (result: any) => {
           // this.report=result.data;
            window.location.href = '/basket';
            this.downloadPopupInfo = false
         //  setTimeout(()=>{},5000);

        }, (error: any) => {
            if (
                error !== undefined &&
                error.response !== undefined &&
                error.response.data !== undefined &&
                error.response.data.message !== undefined
            ) {
                alert(String(error.response.data.message));
                this.downloadPopupInfo = false
            } else {
                alert(String(error));
                this.downloadPopupInfo = false
            }
        });
    };

}
